export default function ArrowIcon({ width = 25 }: { width?: number }) {
  return (
    <svg width={width} height='8' viewBox='0 0 25 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M24.3536 4.03544C24.5488 3.84018 24.5488 3.52359 24.3536 3.32833L21.1716 0.146351C20.9763 -0.0489113 20.6597 -0.0489113 20.4645 0.146351C20.2692 0.341613 20.2692 0.658195 20.4645 0.853458L23.2929 3.68188L20.4645 6.51031C20.2692 6.70557 20.2692 7.02216 20.4645 7.21742C20.6597 7.41268 20.9763 7.41268 21.1716 7.21742L24.3536 4.03544ZM0 3.68188V4.18188H24V3.68188V3.18188H0V3.68188Z'
        fill='currentColor'
      />
    </svg>
  );
}
